import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Routes } from '../../models/routes';
import { FinishProService } from '../../services/finish-pro.service';
import { LoadingProService } from '../../services/loading-pro.service';
import { LanguageService } from '../../services/language.service';
import { PersonalizationsService } from '../../../base/services/personalizations/personalizations.service';
import { Environment } from '../../../models/environment';
import { operationTypeEnum } from '../../../models/operation-type';
import { CustomTextToSignatureContent } from '../../../api/model/customTextToSignatureContent';
import { CustomTextType } from '../document-viewer/types/document-viewer-types';

@Component({
  selector: 'app-thanks',
  templateUrl: './thanks.component.html',
  styleUrls: ['./thanks.component.scss'],
})
export class ThanksComponent implements OnInit {
  showMassiveSection: boolean = true;

  email: string = '';

  isPublic: boolean = true;

  _transParam: boolean = false;

  isOperationNOTE: boolean = false;

  isOperationDWN: boolean = false;

  urlCallback: string = '';

  environment: Environment;

  customText: string = '';

  isVisibleCustomText: boolean = true;

  constructor(
    private _router: Router,
    private _finishProService: FinishProService,
    private _languageService: LanguageService,
    private _loadingPro: LoadingProService,
    private _personalization: PersonalizationsService) {
    this.environment = this._personalization.sendEnv;
  }

  ngOnInit(): void {
    this.isPublic = this._finishProService.isPublic;
    this.email = this._finishProService.operationDetailResponse?.userCreatorEmail;
    this.isOperationDWN = this._finishProService.operationDetailResponse.operationType === operationTypeEnum.DWN ? true : false;
    this.isOperationNOTE = this._finishProService.operationDetailResponse.operationType === operationTypeEnum.NOTE ? true : false;
    this.loadCallbackConfig();
    this.getCustomText();
  }

  ngAfterViewInit(): void {
    this._loadingPro.setLoader(false);
    this._loadingPro.setNextOperationLoader(false);
  }

  getCustomText(): void {
    const content: CustomTextToSignatureContent = this._finishProService.operationDetailResponse?.customTexts?.find(t => t.type === CustomTextType.POSTSIGNVIEW)?.content;
    this.customText = content?.text ? content.text.replace(/{/g, '').replace(/}/g, '') : '';
    this.isVisibleCustomText = content?.visible ?? true;
  }

  exitProcess(): void {
    this._languageService.resetCurrentLanguage();
    this._router.navigate([Routes.DASHBOARD]);
  }

  loadCallbackConfig(): void {
    this.urlCallback = this._finishProService.urlCallbackOK;
    if (this.environment.features.autoRedirect && this.urlCallback) {
      document.location.href = this.urlCallback;
    }
  }

  redirectCallback(url: string): void {
    document.location.href = url;
  }
}
